module.exports = __webpack_public_path__ + "static/cholera-14bb1975bf112dc60ac6880b8135245d.png";